<template>
  <div
    v-if="visible"
    class="image-lightbox-overlay"
    role="dialog"
    aria-modal="true"
    aria-label="Expanded image"
    @click="close"
  >
    <div class="image-lightbox-content" @click.stop>
      <button ref="closeButton" type="button" class="image-lightbox-close" aria-label="Close" @click="close">&times;</button>
      <img :src="src" :alt="alt || 'Expanded image'" class="image-lightbox-img" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageLightbox',
  data () {
    return {
      visible: false,
      src: '',
      alt: '',
      opener: null
    }
  },
  mounted () {
    this._onClick = (event) => {
      const img = event.target
      if (img.tagName === 'IMG' && img.classList.contains('rich-text-image')) {
        this.open(img)
      }
    }
    this._onKeydown = (event) => {
      if (!this.visible) return
      if (event.key === 'Escape') {
        event.preventDefault()
        this.close()
        return
      }
      if (event.key === 'Tab') {
        event.preventDefault()
        if (this.$refs.closeButton) this.$refs.closeButton.focus()
      }
    }
    document.addEventListener('click', this._onClick)
    document.addEventListener('keydown', this._onKeydown)
  },
  beforeUnmount () {
    document.removeEventListener('click', this._onClick)
    document.removeEventListener('keydown', this._onKeydown)
  },
  methods: {
    open (img) {
      this.opener = document.activeElement
      this.src = img.src
      this.alt = img.getAttribute('alt') || ''
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.closeButton) this.$refs.closeButton.focus()
      })
    },
    close () {
      this.visible = false
      this.src = ''
      this.alt = ''
      const opener = this.opener
      this.opener = null
      this.$nextTick(() => {
        if (opener && typeof opener.focus === 'function') opener.focus()
      })
    }
  }
}
</script>

<style scoped>
.image-lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.image-lightbox-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  cursor: default;
}

.image-lightbox-img {
  max-width: 90vw;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.image-lightbox-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  font-size: 32px;
  cursor: pointer;
  line-height: 1;
  padding: 4px 8px;
  opacity: 0.7;
  transition: opacity 0.15s;
}

.image-lightbox-close:hover {
  opacity: 1;
}
</style>
